import {adminHttpClient} from "../commons/adminHttpClient";


const getProgramAuditView = ( id : string) : Promise<any> => {
    return adminHttpClient.get(`/ProgramAudits/View/${id}`);
}

export default getProgramAuditView